import api from './api';

/**
 * Admin client for the Axle repair-order push ledger (the /admin/axle-push
 * endpoints). Backs Administration -> Axle Push: what was sent to Axle
 * Mobility, what's failing, an exact payload preview, and a manual re-push
 * that bypasses the hash dedup.
 */

export interface AxlePushRow {
  repairorder_recno: number;
  delivery_id?: string | null;
  last_pushed_at?: string | null;
  last_error?: string | null;
  attempts?: number | null;
  updated_at?: string | null;
  orderstatus?: string | null;
  pronumber?: number | null;
  chassisid?: string | null;
  container?: string | null;
}

export interface AxlePushSummary {
  total: number;
  delivered: number;
  failing: number;
}

export interface PayloadPreview {
  payload: Record<string, unknown>;
  hash: string;
  differs_from_last_sent: boolean;
}

/** sent / not_sent come back as 200; disabled/rate_limited/error arrive as
 * HTTP 409/429/502 and surface through the axios error path instead. */
export interface ResendResult {
  status: 'sent' | 'not_sent';
}

const base = '/admin/axle-push';

const axlePushService = {
  async list(): Promise<{ rows: AxlePushRow[]; summary: AxlePushSummary }> {
    const res = await api.get(base);
    return res.data as { rows: AxlePushRow[]; summary: AxlePushSummary };
  },

  async payload(recno: number): Promise<PayloadPreview> {
    const res = await api.get(`${base}/${recno}/payload`);
    return res.data as PayloadPreview;
  },

  async resend(recno: number): Promise<ResendResult> {
    const res = await api.post(`${base}/${recno}/resend`);
    return res.data as ResendResult;
  },
};

export default axlePushService;
